module.exports = __webpack_public_path__ + "static/media/240283.f94cf366.png";